import React from "react";
import { X } from "lucide-react";

export default function NotesHistoryModal({ open, onClose, ticketCode, notes }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
      <div className="flex max-h-[85vh] w-full max-w-3xl flex-col rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b px-6 py-4">
          <h3 className="text-lg font-bold tracking-tight">Complete Notes History — {ticketCode}</h3>
          <button onClick={onClose} className="rounded-md p-1 text-muted-foreground hover:bg-slate-100"><X className="h-5 w-5" /></button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-5">
          {notes.length === 0 ? (
            <p className="text-center text-sm text-muted-foreground">No notes yet.</p>
          ) : (
            <div className="space-y-5">
              {notes.map((n) => (
                <div key={n.id} className="border-b border-slate-100 pb-5 last:border-0">
                  <div className="flex items-baseline justify-between gap-4">
                    <p className="text-sm font-bold text-slate-900">{n.author_name || "System"}</p>
                    <p className="text-xs text-slate-500">{new Date(n.created_at).toLocaleString("en-US", { dateStyle: "long", timeStyle: "short" })}</p>
                  </div>
                  <p className="mt-2 whitespace-pre-line text-sm text-slate-700">{n.text}</p>
                  {n.status_changed_to && <p className="mt-1 text-xs text-slate-500">Status changed to: {n.status_changed_to.toUpperCase().replace(/ /g, "_")}</p>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
